import headerCtrl from './header/header.ctrl';
import FooterCtrl from './footer/footer.ctrl';
import modal from './modal/modal.dir';
import errorModal from './error-modal/error-modal.dir';
import changeAddressCtrl from './change-address/change-address.ctrl';
import changeAddressDir from './change-address/change-address.dir';
import contactForm from './contact-form/contact-form.dir';
import lazyImg from './lazy-img/lazy-img.dir';
import smartImg from './smart-img/smart-img.dir';
import liveChat from './live-chat/live-chat.dir';
import loadingOverlay from './loading-overlay/loading-overlay.dir';
import loadingButton from './loading-button/loading-button.dir';
import innerBanner from './inner-banner/inner-banner.dir';
import forgotPasswordDir from './account/forgot-password/forgot-password.dir';
import forgotPasswordCtrl from './account/forgot-password/forgot-password.ctrl';
import amazonPaymentDir from './amazon-payment/amazon-payment.dir';
import shareEmailDir from './social-share/email.dir';
import shareFacebookDir from './social-share/facebook.dir';
import shareTwitterDir from './social-share/twitter.dir';
import sharePinterestDir from './social-share/pinterest.dir';
import shareGoogleDir from './social-share/google.dir';
import shoppingCartDir from './shopping-cart/shopping-cart.dir';
import shoppingCartItemsDir from './shopping-cart/shopping-cart-items.dir';
import paypalPaymentDir from './paypal-payment/paypal-payment.dir';
import stripePaymentDir from './stripe-payment/stripe-payment.dir';
import viralstyleTestimonials from './testimonials/testimonials.dir';
import focusElementDir from './focus-element/focus-element.dir';
import infiniteScrollDir from './infinite-scroll/infinite-scroll.dir';
import homeImageCarousel from './home-image-carousel/home-image-carousel.dir';
import loginDirective from './account/login/login.dir';
import LoginCtrl from './account/login/login.ctrl';
import registerModalDirective from './account/register/register-modal.dir';
import registerFormDirective from './account/register/register-form.dir';
import RegisterCtrl from './account/register/register.ctrl';
import facebookLoginService from './account/facebook-auth/facebook-login-service.js';
import EventBroadcasterCtrl from './account/event-broadcaster/event-broadcaster.ctrl';
import floatLabelText from './float-labels/float-label-text.dir';
import floatLabelSelect from './float-labels/float-label-select.dir';
import fileUploader from './file-uploader/file-uploader';
import googleAddressAutocomplete from './google-address-autocomplete/google-address-autocomplete.dir';

export default angular.module('cui.layoutComponents', [])
  .controller('HeaderCtrl', headerCtrl)
  .controller('FooterCtrl', FooterCtrl)
  .directive('cuiModal', modal)
  .directive('errorModal', errorModal)
  .controller('changeAddressCtrl', changeAddressCtrl)
  .directive('changeAddress', changeAddressDir)
  .directive('lazyImg', lazyImg)
  .directive('smartImg', smartImg)
  .directive('liveChat', liveChat)
  .directive('cuiLoadingOverlay', loadingOverlay)
  .directive('cuiLoadingButton', loadingButton)
  .directive('innerBanner', innerBanner)
  .directive('amazonPayment', amazonPaymentDir)
  .directive('paypalPayment', paypalPaymentDir)
  .directive('shoppingCart', shoppingCartDir)
  .directive('shoppingCartItems', shoppingCartItemsDir)
  .directive('stripePayment', stripePaymentDir)
  .directive('viralstyleTestimonials', viralstyleTestimonials)
  .directive('focusElement', focusElementDir)
  .directive('infiniteScroll', infiniteScrollDir)
  .directive('homeImageCarousel', homeImageCarousel)
  .directive('contactForm', contactForm)
  // Auth Controls
  .directive('cuiLogin', loginDirective)
  .controller('LoginCtrl', LoginCtrl)
  .directive('forgotPassword', forgotPasswordDir)
  .controller('forgotPasswordCtrl', forgotPasswordCtrl)
  .directive('registerForm', registerFormDirective)
  .directive('cuiRegister', registerModalDirective)
  .controller('RegisterCtrl', RegisterCtrl)
  .service('FacebookLoginService', facebookLoginService)
  .controller('EventBroadcasterCtrl', EventBroadcasterCtrl)
  // End Auth Controls
  // Begin Social Share
  .directive('emailShare', shareEmailDir)
  .directive('facebookShare', shareFacebookDir)
  .directive('twitterShare', shareTwitterDir)
  .directive('pinterestShare', sharePinterestDir)
  .directive('googleShare', shareGoogleDir)
  // End Social Share
  .directive('floatLabelText', floatLabelText)
  .directive('floatLabelSelect', floatLabelSelect)
  .directive('fileUploader', fileUploader)
  .directive('googleAddressAutocomplete', googleAddressAutocomplete)
;



// WEBPACK FOOTER //
// ./source/client/layout-components/index.js